module.exports = __webpack_public_path__ + "static/media/Tab_StazioniMisuraGreyCluster.2948df7c.svg";